<app-left-side-nav></app-left-side-nav>
<app-header></app-header>

<!-- page content area start -->
<div class="afterLoginPageContainer">
    <div class="container px-0">
        <div class="mainContent"
        infiniteScroll 
        [infiniteScrollDistance]="2"
        [infiniteScrollUpDistance]="1.5"
        [infiniteScrollThrottle]="50" 
        (scrolled)="onScrollDown()">
            <div class="catalog-header">
                <div class="top-bar">
                    <div class="wrapper">
                        <button class="back-btn" >
                            <a (click)="onClickBack()">
                                <i class="fa fa-arrow-left"></i>
                            </a>
                        </button>
                        <div class="title-section">
                            <div class="outer">
                                <img class="icon" src="/assets/images/short-list-icon.png" alt="shortlist icon" />
                            </div>
                            <div class="info">
                                <h2 class="title">My Shortlist</h2>
                                <p> <span class="me-1">{{ productsCount }} {{ productsCount <= 1 ? 'Product' : 'Products' }}</span> 
                                     | <span class="ms-1">{{ companiesCount }} {{ companiesCount <=1 ? 'Company' : 'Companies' }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="icons">
                        <i class="fa fa-search" id="searchIcon" (click)="openFloatingSearch()"></i>
                    </div>
                </div>

                <!-- Floating Search Bar -->
                <div class="floating-search" id="floatingSearch" [class.active]="isSearchOpen">
                    <div class="search-container">
                        <i class="fa fa-search" (click)="onSearchIconClick()"></i>
                        <input type="text" 
                        placeholder="Search..." 
                        id="searchInput" 
                        [(ngModel)]="searchText"
                        (ngModelChange)="onSearchInput()"
                        #searchInput 
                        />
                        <i class="fa fa-times" id="closeSearch" (click)="closeFloatingSearch()"></i>
                    </div>
                </div>
                <div class="tabs">
                    <div class="tab-item active">
                        <img class="icon" src="/assets/images/product-icon.png" alt="product icon" />
                        <span>Products</span>
                    </div>
                    <div class="tab-item" (click)="routeTocompaniesWishList()">
                        <img class="icon" src="/assets/images/company-icon.png" alt="company icon" />
                        <span>Companies</span>
                    </div>
                </div>
            </div>
            <div class="tab-content" *ngIf="isDataLoaded">
                <div class="title-section" *ngIf="paramsToFetchData.search">
                    <div class="info">
                        <h2 class="title"><span class="txt">Search results for:</span> "{{ searchText }}" </h2>
                    </div>
                </div>
                <div class="product-list" *ngIf="productList && productList.length > 0; else noProductsTemplate">
                    <div class="block" *ngFor="let product of productList">
                        <a (click)="viewProductDetails(product.encoded_product_id)">
                            <div class="card">
                                <div class="wrapper position-relative">
                                    <img class="card-img-top"
                                        [src]="product.media_type === 'image' ? product.media_url : product.bigthumb_url"
                                        alt="{{ product.title_english }}">
                                    <span *ngIf="product.media_type === 'youtubevideo'" class="playicon">
                                        <i class="fa-brands fa-youtube"></i>
                                    </span>
                                </div>
                                <div class="card-body">
                                    <h6 class="product-name">{{ product.title_english }}</h6>
                                    <p class="company-name">{{ product.brandname }}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="section-loader text-center mx-auto" *ngIf="isLoadingMore">
                        <div class="spinner-border text-success" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
                <ng-template #noProductsTemplate>
                    <div class="no-data">
                        <p>No Records Found.</p>
                    </div>
                </ng-template>
                <div class="catlogWrapper mt-1" (click)="goToTicketPage()" *ngIf="this.eventDetails?.allow_to_register === 1">
                    <img src="/assets/images/buy_your_ticket.png" alt="Go To Digital Catalogue" />
                </div>
            </div>          
        </div>
    </div>
</div>